import React, { Component } from 'react';
import './index.scss';
import {Icon, Menu, Avatar} from 'antd';
import { withRouter } from 'react-router-dom';
import {subscribe} from 'alfa';
import UserRepo from '../../repository/user';

class Topbar extends Component {
  renderNoUser() {
    return (
      <div>
      </div>
    )
  }

  renderWithUser() {
    const { user } = this.props;

    return (
      <>
        <div className="menu-logo" />
        <Menu
          mode='horizontal'
          selectable={false}
          theme="dark"
          style={{ lineHeight: '64px' }}
        >
          <Menu.Item key="1" onClick={() => { this.props.history.push("/business") }} >
            <Icon type="shop" />
            Business
          </Menu.Item>
          <Menu.Item key="2" onClick={() => { this.props.history.push("/users") }} >
            <Icon type="user" />
            Users
          </Menu.Item>

          <Menu.SubMenu style={{ float: 'right' }} title={
            <span className="submenu-title-wrapper">
              <Avatar  src={user.picture} /> {user.name}
              <Icon style={{ fontSize: '12px' }} type='down' />
            </span>
          }>
            <Menu.Item key={`user-${user.id}-logout`} onClick={() => { localStorage.clear(); UserRepo.logout().then(() => {window.location = "/"}); }}>
              <Icon type='logout' /> Sign out
            </Menu.Item>
          </Menu.SubMenu>
        </Menu>
      </>
    )
  }

  render() {
    const { user } = this.props;
    return user !== null ? this.renderWithUser() : this.renderNoUser();
  }
}

export default subscribe(withRouter(Topbar), ['user']);
